import {getApi} from "@/api-ts/api";
import { WidgetContentItemsApi } from "@/api-ts/widget-content-items";
import {SET_CONTENT_ITEMS_WIDGET} from "@/store/general/widget-content-items/mutations";
import {ActionTree} from 'vuex';
import {WidgetContentItemsState} from "@/store/general/widget-content-items/state";

export const FETCH_CONTENT_ITEMS_WIDGET = 'fetchContentItemsWidget';

const actions: ActionTree<WidgetContentItemsState, any> = {
	async [FETCH_CONTENT_ITEMS_WIDGET](context, {projectId, payload}) {
		const widgetApi = getApi<WidgetContentItemsApi>(WidgetContentItemsApi.name);
		const data = await widgetApi.fetchContentItems(projectId, payload);
		context.commit(SET_CONTENT_ITEMS_WIDGET, data);
	},
}

export default actions;
